import axios from "axios";

// Create a separate API client for the search service
export const searchApiClient = axios.create({
  baseURL: process.env.REACT_APP_SEARCH_API_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

// Error handling
searchApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Search API error:", error);
    return Promise.reject(error);
  }
);
